import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMatches } from 'react-router';

import { useBrandTheme } from '@shared/lib/brandTheme';

// Sets document.title from the deepest matched route's handle.title, falling back to the
// brand name alone when the current route has none (e.g. relay/callback routes).
export const usePageTitle = () => {
	const matches = useMatches();
	const { title: brandTitle } = useBrandTheme();
	const { t } = useTranslation();

	const currentRoute = matches.slice().reverse().find((m) => m.handle?.title);

	useEffect(() => {
		document.title = currentRoute?.handle?.title
			? `${t(currentRoute.handle.title)} — ${brandTitle}`
			: brandTitle;
	}, [currentRoute, t, brandTitle]);
};
